
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqfXCqdkTldcTICaAI95F2pAd3qzameMPuPs7vjfZopn4Meta } from "/codebuild/output/src3921345017/src/src/pages/faq.vue?macro=true";
import { default as menueLDK8Z1zpc2ZhJXIQp0P74Xj5KpNGatbjHJw8rGQ6y8Meta } from "/codebuild/output/src3921345017/src/src/pages/menu.vue?macro=true";
import { default as indexenFecREdol2s8qAJpKDPhL1S6NlZiB1HQ6osXGQo1YQMeta } from "/codebuild/output/src3921345017/src/src/pages/index.vue?macro=true";
import { default as contactl902pWFcmFgt3NHe1vOLzevPyCFmGPNXqJCVq3v4zvYMeta } from "/codebuild/output/src3921345017/src/src/pages/contact.vue?macro=true";
import { default as tutorialsbqoAhMPGzp9LFPga_45FewE7mcWLBn7_459oJA8Z4Q798wMeta } from "/codebuild/output/src3921345017/src/src/pages/tutorial.vue?macro=true";
import { default as agreementGR_EBfBuDDKwmLoBar7c2dPL9kYlOzsuFgNlhTosRYoMeta } from "/codebuild/output/src3921345017/src/src/pages/agreement.vue?macro=true";
import { default as about_45passh256LFWUjRYeErkXUAw0NWFe9bm5B4kskJEqjbo6_0QMeta } from "/codebuild/output/src3921345017/src/src/pages/about-pass.vue?macro=true";
import { default as index6SeORSD9ZW1v8pdxfC_1NIWmuqQselDa3wM5GDCWGWYMeta } from "/codebuild/output/src3921345017/src/src/pages/card/index.vue?macro=true";
import { default as _91id_939aE60P4tIA4cVOgpk7kpcKPa5BI7AlPHcB_45FOdiMvM4Meta } from "/codebuild/output/src3921345017/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceQ33jixQNEqTS4bM6cgk2dnomrG0MsLEX_45r_45MPqBNTKEMeta } from "/codebuild/output/src3921345017/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93KxWKIta92LPuJBuuzx_y71ZySZ6Z_v1I0ZaaDL_455kfcMeta } from "/codebuild/output/src3921345017/src/src/pages/notice/[id].vue?macro=true";
import { default as indexjJoxXvs1vsuEBxW_45hReTuU68B2rB_45vVzMuy4yvPZ56wMeta } from "/codebuild/output/src3921345017/src/src/pages/coupon/index.vue?macro=true";
import { default as index_458gQnmC9jN_45ZZRAc0iZ_En9Ytp0OQobv3iRvjVXfRbMMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/index.vue?macro=true";
import { default as indexYCfGefJ16Pv9aXLk0KrSE9ocycEv6druTHwLax7IS90Meta } from "/codebuild/output/src3921345017/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93zLr_7MVYbcLQ7BXD6RhKn1_45tfj40vJjo2PbEfeaCZOUMeta } from "/codebuild/output/src3921345017/src/src/pages/parking/[id].vue?macro=true";
import { default as indexkM5X07zrqPgtTAarZp8xEOWxqwcEPP_IOMpUyBUL60gMeta } from "/codebuild/output/src3921345017/src/src/pages/history/index.vue?macro=true";
import { default as indexYEi7BuO00l_45vQX7i8eMhVROtabA5U7yRlPbIfa6Yb8gMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/index.vue?macro=true";
import { default as indexM3ExXMaHwwpeDmgyeOhBn1QvzqrXjfs6dquY8NDxLqIMeta } from "/codebuild/output/src3921345017/src/src/pages/sign-in/index.vue?macro=true";
import { default as index2K_45yFATr76uIzE6dWRwiWzRHJ1uWhZv5LYcK9cWoNQsMeta } from "/codebuild/output/src3921345017/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviKsSnoed4WIHTKQSxVVVxaFCZHZIGwHAw6ympaKIHGeMMeta } from "/codebuild/output/src3921345017/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit4krX56iEw0b2M_45mkRS_45Z7kB0UzxwzH_45UUUVxqYesvC8Meta } from "/codebuild/output/src3921345017/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementP4E3mv9srWybwVccb_45DaBJdist1ChnZ2mrhyTZ_45XYU8Meta } from "/codebuild/output/src3921345017/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexG9nPPbEjEXXcj_DusY7jgiyIAyV8ByHT_wt1uy0BogIMeta } from "/codebuild/output/src3921345017/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dKI00nM1DS9Fh8cTymyFn3qudvpsMfTzF0sSxGwo75dYMeta } from "/codebuild/output/src3921345017/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmJIHQJ7c2WDwFgd2EFRbIDQIy_45JcxWzMpzYhODAV6pMgMeta } from "/codebuild/output/src3921345017/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexpma_T6074rKyjJAFRsDKn_45xVUaN26d1kAv3lut900hkMeta } from "/codebuild/output/src3921345017/src/src/pages/card/create/index.vue?macro=true";
import { default as index5xfqIcpwck7scuSWmWPJG3nWb2bTtBmmymwqF8AfxykMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm4R_45Vloljs3uZZypVikrBbaApGMSbMNY_N_45kpTdLVQxAMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmG0ki2yVpvbwBAtR50_45wEDjHosXuoFkBCm0j7bdxCeNoMeta } from "/codebuild/output/src3921345017/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completefCr3JrW4_45ynZx_45U_n0FL_iR4XHpo_45YIcfvVkKWehcwEMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/complete.vue?macro=true";
import { default as registerHzKJVADluoP_459R55NxrG3hfjLYUh7O1ch6NnhBg4ttUMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_9362zi0PCQih1JK1zxzzccyfJrCBRi7W4Tp9xhBwFh3f4Meta } from "/codebuild/output/src3921345017/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm0kLOukxu_45VTGdbiG6O5qE4XVd7CvMKZQauowVfCP4OEMeta } from "/codebuild/output/src3921345017/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93Bp1OBiQOTA1dKwMsZHJWZiWji16APwxFo3xsiHcSHI8Meta } from "/codebuild/output/src3921345017/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexqmvZFWW0qil7lOf8q7x5KgSL687SLCSrNXHOt0jwrKMMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeVCZ14IC6qRDlWxiWzsvyTVIpaLxKUsh8UxXEjheLdqIMeta } from "/codebuild/output/src3921345017/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeAKcmPObA9FEejKKsN66cInnLtbK_45GRJ1pfbi_NFZaB0Meta } from "/codebuild/output/src3921345017/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeILe_ltTQ3GBYnyQQliMqAWhxMmugeNBTbtTp7z8wZTcMeta } from "/codebuild/output/src3921345017/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerqpFMKAte09K7bpd_45xx0_2_45O2YVxMhxTDQmT_MHBEJIkMeta } from "/codebuild/output/src3921345017/src/src/pages/contact-form/register.vue?macro=true";
import { default as completehR3xovQaP5FUq2y6C6p9MiLqLajwLW528YIwmaqIoQoMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index22GNsu9huVPYZKdm_450Uodbog2iVlxgn_q_45JjYQB3Lj8Meta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmFvff8t1Drm9UtC8gXjHmfM79WTiTtb0oB7bePZoUWhsMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeZapjCpUyFMYta_45isJgBuYTk_j0KmwDH1zE_mYh_45tU18Meta } from "/codebuild/output/src3921345017/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexcYs1AFTHhG_45Gym0fLaCXyDoOd__sMQa8tyZqSvGnXVoMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93C7bnRXOS6S9AQg3KYLvjAo4V0uOgKgKadUs3YoGZ3akMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete77zmN2YGDmDg2BhUl97D9Caal_jx2_45_45apSSM38GYZEcMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasjhhbLstvVobYyobO0ZPXAfv_456l1a9SQu2Qmg1MwA8kQMeta } from "/codebuild/output/src3921345017/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleYbJIbxdMQd6tVjlASrMSzWDtOgpydfFgU5y8UmNGRoIMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailejDsiSQR_GybhE9xmzAanrJ2nd6yfj7g_45vOxy8F8HT0Meta } from "/codebuild/output/src3921345017/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmo0H5lRq4by6TIbKCuY0_45RUFBoe_45pKJdEMkIpuewRgHMMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentZduX_45nzX5tk0zcFhLdmJ7t3Z6BRU2o08HXz_Tt_458y8kMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmLD9XlI3Zd5_3ALvq02VRPXZfgVXwsfkU9tL5VHoT5cAMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatef_UMlnxJK1yF3YbFO_45In6_45uSxEmYYueYznNp_45FlVJIoMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeSP8jlSVmCx1wzojMVK_6ULjk8Ta93ZQfCNe186Z4f4wMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeElpo7B4RjcnNsik1CB5VgxWOqdbSySDyeoWwIl_45L1QMMeta } from "/codebuild/output/src3921345017/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordskeHYE6nR3fVWhclz6OWnSdiqoKLC8gfyWaStQxgJ6EMeta } from "/codebuild/output/src3921345017/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasNN9dVpF_O3TVprFDA3501nFTOHIjtc7dLJWBHPhtU_MMeta } from "/codebuild/output/src3921345017/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerJ9HQiFi8Wg_jNqVlCwLH9lJBtIyPVkGLeD8i8HbmcskMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeTlNOAc4tZsj2mrcS4mX053TUezjTrbfQQWWQyvIsBFAMeta } from "/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexoHw0LMKEbS_45miq7uyMGpBsM51R6NM8d3kU0j22P_EIgMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexTHRz0nHLSkw9Dxh_tQbLu3QI0Q86clDZfSVOoqLna6MMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexawsbQ8xCdR_a9tG_45ayVMR8BlgrMxzAUH1b_m1YSyfCMMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexNaILYDNXg6hTaKKRZTGswTmNcY5CP1OTl4HR_4578oiE0Meta } from "/codebuild/output/src3921345017/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateApao57xdg_kZT_45vOUdRyrW7_45UD4aTlmpVCjhzL6GNt4Meta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeFz_455S_45DIKyp5dchnM73jw59Pe0atewTg3PxLP4ylU_gMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmjCSiLcTsM0ZFjEYbNT_45EO7BHygX0DNhpCRowdlPWvVAMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexULWYgoxmUz_45uiIPxFkNO9vxwozzU6kF6_8dL8vy4Vh8Meta } from "/codebuild/output/src3921345017/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeDJ8HTzrzRhL6D4A0Z80fSZI8ILbxJYSMDt2_gGAeu2AMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update0AuBCf_45YNkCYm6DiXmmQuLh0p_AkwYAR0VYDtyRvh_MMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIEsfk6TFx3ci_45OSD7cuPdgnQPPf1_45mb6VmgX4LK3CaoMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexQk4HrawqQYYbRxx7RUtEtJnu5ypDfkyDVX23JtcPqqwMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeTwTWyxqGCHlvE_45fxxsBntC4NmeUMUHtejlF2trXql_MMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexeC0o5vrYnRb1HLgaf5LceOe5e7CtnT2hEp22w0q8BhcMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeAMQfgCmP7XtQW7LiKwS0vscZ2IPpv_45exG5877JiyNw8Meta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as index4YEZ8IkBfAZr1oug_iQSKLlPMSiwVKM2vMMPLEw3HCYMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexlbquziLQC_45KDR_45HkgmaL6HP_Lunkwb6P_dDDG76kGjoMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexJIm5O_45Ajn_4598WpCcmRVO35slSdEYjPWYF2jhVK_7atEMeta } from "/codebuild/output/src3921345017/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateweGwqrf9OvahrlOoFKaUh_FNC3RXRTUf_45XUsoYgDd3wMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmyVkV1_UwPWZF33Iz25hnDDgaBHorLewlsP3_45b25qoCQMeta } from "/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menueLDK8Z1zpc2ZhJXIQp0P74Xj5KpNGatbjHJw8rGQ6y8Meta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexenFecREdol2s8qAJpKDPhL1S6NlZiB1HQ6osXGQo1YQMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexjJoxXvs1vsuEBxW_45hReTuU68B2rB_45vVzMuy4yvPZ56wMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexkM5X07zrqPgtTAarZp8xEOWxqwcEPP_IOMpUyBUL60gMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexM3ExXMaHwwpeDmgyeOhBn1QvzqrXjfs6dquY8NDxLqIMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index2K_45yFATr76uIzE6dWRwiWzRHJ1uWhZv5LYcK9cWoNQsMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexpma_T6074rKyjJAFRsDKn_45xVUaN26d1kAv3lut900hkMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm4R_45Vloljs3uZZypVikrBbaApGMSbMNY_N_45kpTdLVQxAMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmG0ki2yVpvbwBAtR50_45wEDjHosXuoFkBCm0j7bdxCeNoMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completefCr3JrW4_45ynZx_45U_n0FL_iR4XHpo_45YIcfvVkKWehcwEMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerHzKJVADluoP_459R55NxrG3hfjLYUh7O1ch6NnhBg4ttUMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm0kLOukxu_45VTGdbiG6O5qE4XVd7CvMKZQauowVfCP4OEMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeVCZ14IC6qRDlWxiWzsvyTVIpaLxKUsh8UxXEjheLdqIMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeAKcmPObA9FEejKKsN66cInnLtbK_45GRJ1pfbi_NFZaB0Meta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeILe_ltTQ3GBYnyQQliMqAWhxMmugeNBTbtTp7z8wZTcMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerqpFMKAte09K7bpd_45xx0_2_45O2YVxMhxTDQmT_MHBEJIkMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmFvff8t1Drm9UtC8gXjHmfM79WTiTtb0oB7bePZoUWhsMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeZapjCpUyFMYta_45isJgBuYTk_j0KmwDH1zE_mYh_45tU18Meta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexcYs1AFTHhG_45Gym0fLaCXyDoOd__sMQa8tyZqSvGnXVoMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete77zmN2YGDmDg2BhUl97D9Caal_jx2_45_45apSSM38GYZEcMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleYbJIbxdMQd6tVjlASrMSzWDtOgpydfFgU5y8UmNGRoIMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailejDsiSQR_GybhE9xmzAanrJ2nd6yfj7g_45vOxy8F8HT0Meta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmo0H5lRq4by6TIbKCuY0_45RUFBoe_45pKJdEMkIpuewRgHMMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentZduX_45nzX5tk0zcFhLdmJ7t3Z6BRU2o08HXz_Tt_458y8kMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmLD9XlI3Zd5_3ALvq02VRPXZfgVXwsfkU9tL5VHoT5cAMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeSP8jlSVmCx1wzojMVK_6ULjk8Ta93ZQfCNe186Z4f4wMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeElpo7B4RjcnNsik1CB5VgxWOqdbSySDyeoWwIl_45L1QMMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordskeHYE6nR3fVWhclz6OWnSdiqoKLC8gfyWaStQxgJ6EMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerJ9HQiFi8Wg_jNqVlCwLH9lJBtIyPVkGLeD8i8HbmcskMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeTlNOAc4tZsj2mrcS4mX053TUezjTrbfQQWWQyvIsBFAMeta || {},
    component: () => import("/codebuild/output/src3921345017/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3921345017/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]